/**
 * 「**굵게**」 표시가 든 한 문장을 조각 배열 `[{ text, strong }]` 로 바꾼다 (2026-09-07 전수 검수).
 *
 * 왜: 문장을 「앞 조각 + 굵은 조각 + 뒤 조각」 세 키로 쪼개 이어 붙이면 한국어에서는 자연스럽지만
 * 영어·중국어에서는 어순이 달라 「named by the rights holder Brand channel only」 처럼 깨진다.
 * 문장 전체를 사전 한 키로 두고 굵은 자리만 `**…**` 로 표시하면 언어마다 어순을 바꿀 수 있다.
 * 한국어 출력은 종전 조각 배열과 바이트 단위로 같다(테스트가 지킨다).
 */
export const seg = (text, strong = false) => ({ text, strong });

export function segsFromMarked(str) {
  const out = [];
  String(str || "")
    .split(/(\*\*[^*]+\*\*)/)
    .forEach((part) => {
      if (!part) return;
      if (part.startsWith("**") && part.endsWith("**")) out.push(seg(part.slice(2, -2), true));
      else out.push(seg(part));
    });
  return out;
}

export default segsFromMarked;
